import * as api from "app/api/sportsApi";
import BetDrawerButton from "app/components/BetDrawerButton/BetDrawerButton";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { SessionHelper } from "app/helpers/sessionHelper";
import OpenBetsContent from "app/screens/EventsScreen/screens/BetDrawerScreen/components/OpenBetsList/components/OpenBetsContent/OpenBetsContent";
import { UserType } from "app/types/userType";
import {
  BetslipListTypes,
  ReportTypes,
  ResponsiveScreenSizes,
} from "app/utils/const";
import cx from "classnames";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import type { IntlShape } from "react-intl";
import { FormattedMessage, injectIntl } from "react-intl";
import Media from "react-media";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import MobileReportSummary from "./components/MobileReportSummary/MobileReportSummary";
import ResultsCountContent from "./components/ResultsCountContent/ResultsCountContent";
import SettledBets from "./components/SettledBets/SettledBets";
import Transactions from "./components/Transactions/Transactions";
import "./MobileReportsScreen.scss";
import "./MobileReportsScreenTablet.scss";

function MobileReportsScreen(props: {
  loadSettledReports: (...args: Array<any>) => any;
  loadTransactions: (...args: Array<any>) => any;
  isReportListLoading: boolean;
  reportList: any;
  numberOfReports: number;
  currentBetsCount: number;
  showNotificationDisplay: boolean;
  intl: IntlShape;
  getLatestOpenBetsForPanel: Function;
  user: UserType;
  openBetsReportList: any;
}) {
  const {
    loadSettledReports,
    loadTransactions,
    isReportListLoading,
    reportList,
    numberOfReports,
    showNotificationDisplay,
    intl,
    getLatestOpenBetsForPanel,
    openBetsReportList,
  } = props;

  const location: any = useLocation();
  const [query, setQuery] = useState("");
  const [transactionType, setTransactionType] = useState<any>("");
  const [tab, setTabValue] = useState(
    location.state ? location.state.tab : ReportTypes.CURRENT
  );
  const [sports, setSports] = useState([]);
  const [selectedSportId, setSelectedSportId] = useState();
  const [after, setAfter] = useState(
    dayjs().startOf("day").subtract(3, "months").unix()
  );
  const [before, setBefore] = useState(dayjs().unix());
  const [openBetsSelectedTab, setOpenBetsSelectedTab] = useState(
    BetslipListTypes.SINGLES
  );
  const setOpenBetsTab = tab => {
    setOpenBetsSelectedTab(tab);
  };

  useEffect(() => {
    getLatestOpenBetsForPanel({
      perPage: 15,
    });
  }, [getLatestOpenBetsForPanel, openBetsSelectedTab]);

  useEffect(() => {
    if (location.state) {
      setTransactionType(location.state.transactionType);
      location.state.transactionType = "";
    } else {
      setTransactionType("all");
    }
    loadReport();
    getSports();
    // legacy componentWillUnmount
    return () => {
      if (location.state) {
        location.state = {};
      }
    };
  }, []);

  useEffect(() => {
    loadReport();
  }, [tab]);

  const setTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }
    setTabValue(tabType);
  };

  const getSports = () => {
    api.fetchSports().then(resp => {
      setSports(resp.sports);
    });
  };

  const getTabs = () => {
    return [
      {
        title: `${intl.formatMessage({
          id: "bets-slip-open-bets",
        })}`,
        callback: () => setTab(ReportTypes.CURRENT),
        isActive: tab === ReportTypes.CURRENT,
      },
      {
        title: intl.formatMessage({
          id: "reports-setbets",
        }),
        callback: () => setTab(ReportTypes.SETTLED),
        isActive: tab === ReportTypes.SETTLED,
      },
      {
        title: intl.formatMessage({
          id: "reports-trans",
        }),
        callback: () => setTab(ReportTypes.TRANSACTIONS),
        isActive: tab === ReportTypes.TRANSACTIONS,
      },
    ];
  };

  const getContent = () => {
    if (reportList == null) {
      return null;
    }

    if (tab === ReportTypes.SETTLED) {
      const content = isReportListLoading ? (
        <LoadingSpinner />
      ) : (
        <SettledBets bets={reportList} tab={tab} />
      );
      return content ? (
        content
      ) : (
        <div className="blank">
          <ResultsCountContent
            isReportListLoading={isReportListLoading}
            numberOfReports={numberOfReports}
            resetParticipantSearch={event => resetParticipantSearch()}
            query={query}
            tab={tab}
          />
        </div>
      );
    } else if (tab === ReportTypes.CURRENT) {
      let content = isReportListLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <OpenBetsContent
            reportList={openBetsReportList}
            isReportListLoading={isReportListLoading}
          />
        </>
      );
      return content;
    } else if (tab === ReportTypes.TRANSACTIONS) {
      const content = isReportListLoading ? (
        <LoadingSpinner />
      ) : (
        (reportList.length > 0 &&
          reportList.map(transaction => {
            if (transaction.amount != null) {
              return (
                <Transactions
                  detail={transaction.detail}
                  amount={transaction.amount}
                  balance={transaction.balance}
                  type={transaction.type}
                  transactionId={transaction.transactionId}
                  date={transaction.date}
                  key={transaction.id}
                  status={transaction.status}
                />
              );
            } else {
              return null;
            }
          })) ||
        (reportList.length === 0 && (
          <div className="blank">
            {" "}
            <ResultsCountContent
              isReportListLoading={isReportListLoading}
              numberOfReports={numberOfReports}
              resetParticipantSearch={event => resetParticipantSearch()}
              query={query}
              tab={tab}
            />
          </div>
        ))
      );
      return content;
    }
  };

  const loadReport = () => {
    switch (tab) {
      case ReportTypes.CURRENT:
        getLatestOpenBetsForPanel({
          perPage: 15,
        });
        break;

      case ReportTypes.SETTLED:
        loadSettledReports({
          selectedSportId: selectedSportId,
          event: query,
          after: after,
          before: before,
          perPage: 20,
        });
        break;

      case ReportTypes.TRANSACTIONS:
        loadTransactions({
          after: after,
          before: before,
          transactionType: transactionType,
          participant: query,
          size: 20, //FIXME: It should be handle by an lazy loading at the infinite scroll in the mobile view.
          page: 0,
          show: transactionType,
        });
        break;

      default:
        return;
    }
  };

  const resetParticipantSearch = () => {
    setQuery("");
    loadReport();
  };

  const content = getContent();

  return (
    <div
      className={cx("reports-screen-wrapper", {
        "reports-screen-wrapper--notifications-active": showNotificationDisplay,
        "reports-screen-wrapper-asian":
          SessionHelper.isAsianRouteAndSessionView(),
      })}
    >
      <MobileReportSummary
        tab={tab}
        getTabs={getTabs()}
        isReportListLoading={isReportListLoading}
      />
      {/* mobile report list contents component */}
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => (
          <React.Fragment>
            <div className="reports__list">
              {content}
              <div className="reports__list__note">
                {(tab === ReportTypes.SETTLED ||
                  tab === ReportTypes.TRANSACTIONS) && (
                  <FormattedMessage tagName="span" id="reports-mobile-note" />
                )}
              </div>
            </div>
            <BetDrawerButton />
          </React.Fragment>
        )}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  numberOfReports: state.reportListModel.numberOfReports,
  currentBetsCount: state.betSlipListModel.currentBetsCount,
  showNotificationDisplay: state.notificationListModel.showNotificationDisplay,
  user: state.userModel.user,
  isReportListLoading: state.openBetsListModel.isReportListLoading,
  openBetsReportList: state.openBetsListModel.openBetsPanelList,
  reportList: state.reportListModel.reportList,
});

const mapDispatchToProps = (dispatch: any) => ({
  getLatestOpenBetsForPanel: (payload: {
    size: number;
    page: number;
    betType: string;
  }) => {
    dispatch.openBetsListModel.loadOpenBetsPanelList(payload);
  },
  loadSettledReports: params => {
    dispatch.reportListModel.loadSettledReportList(params);
  },
  loadTransactions: params => {
    dispatch.reportListModel.loadTransactions(params);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MobileReportsScreen));
